<template>
  <div class="videobox">
    <div ref="videoPlayer"></div>
  </div>
</template>
<script>
  import flvjs from 'flv.js'
  export default {
    props: {
      videoUrl: {
        type: String
      },
      height: {
        type: Number
        // default:600
      },
      displayForm: {
        type: Boolean
      },
      poster: {
        type: String
      }
    },
    data() {
      return {
        flvPlayer: null,
        retryCount: 0,
        maxRetries: 5
      }
    },
    watch: {
      videoUrl: {
        handler(newVal) {
          if (newVal) {
            this.$nextTick(() => {
              this.initPlayer()
            })
          }
        },
        immediate: true
      }
    },
    methods: {
      initPlayer() {
        this.destroyPlayer() // 先销毁旧实例，防止内存泄漏
        console.log(this.videoUrl,'this.videoUrl');
        
        if (this.videoUrl.indexOf('.mp4') == -1 && this.videoUrl.indexOf('.flv') == -1) {
          const search = new URL(this.videoUrl).search
          this.initVideoStream(search)
        } else if (this.videoUrl.indexOf('.flv') != -1) {
          this.initFlvPlayer(this.videoUrl)
        } else {
          this.initVideoPlayer(this.videoUrl)
        }
      },
      initVideoStream(search) {
        const params = new URLSearchParams(search)

        const streams = params.getAll('src')
        const modes = params.getAll('mode')
        if (modes.length === 0) modes.push('')

        while (modes.length > streams.length) {
          streams.push(streams[0])
        }
        while (streams.length > modes.length) {
          modes.push(modes[0])
        }

        if (streams.length > 1) {
          document.body.className = 'flex'
        }

        const background = params.get('background') !== 'false'

        const videoPlayer = this.$refs.videoPlayer

        for (let i = 0; i < streams.length; i++) {
          /** @type {VideoStream} */
          const video = document.createElement('video-stream')
          video.background = background
          video.mode = modes[i] || video.mode
          video.style.width = '100%'
          video.src = new URL('api/ws?src=' + encodeURIComponent(streams[i]), this.videoUrl)
          videoPlayer.appendChild(video)
        }
      },
      initVideoPlayer(url) {
        const vPlayer = this.$refs.videoPlayer
        const video = document.createElement('video')
        video.id = 'videoPlayer'
        video.style.width = '100%'
        video.style.height = '100%'
        video.style.objectFit = 'fill'
        video.src = url
        video.autoplay = true
        video.controls = false
        vPlayer.appendChild(video)
      },
      initFlvPlayer() {
        const vPlayer = this.$refs.videoPlayer
        const video = document.createElement('video')
        video.id = 'videoPlayer'
        vPlayer.appendChild(video)
        if (!video) return
        if (flvjs.isSupported() && this.videoUrl) {
          this.flvPlayer = flvjs.createPlayer(
            {
              type: 'flv',
              url: this.videoUrl,
              isLive: true,
              cors: true,
              withCredentials: false
            },
            {
              autoCleanupSourceBuffer: true,
              enableStashBuffer: false,
              enableWorker: true,
              stashInitialSize: 128
            }
          )
          this.flvPlayer.attachMediaElement(video)
          this.flvPlayer.load()
          this.flvPlayer.play()
        }
      },
      destroyPlayer() {
        // 清理视频元素
        const vPlayer = this.$refs.videoPlayer

        if (this.flvPlayer) {
          try {
            // 强制停止播放
            this.flvPlayer.pause()
            // 卸载媒体元素
            this.flvPlayer.detachMediaElement()
            // 销毁播放器实例
            this.flvPlayer.destroy()
            // 清理播放器引用
            this.flvPlayer = null
          } catch (error) {
            console.warn('销毁播放器时出现错误:', error)
            // 即使出错也要强制清理引用
            this.flvPlayer = null
          }
        }

        if (vPlayer) {
          // 移除所有 video-stream 元素
          const videoStreams = vPlayer.querySelectorAll('video-stream')
          videoStreams.forEach(video => {
            // 如果 video-stream 有 pause/destroy/ondisconnect 方法可以调用
            if (typeof video.pause === 'function') video.pause()
            if (typeof video.destroy === 'function') video.destroy()
            if (typeof video.ondisconnect === 'function') video.ondisconnect()
            vPlayer.removeChild(video)
          })

          // 移除所有 video 元素
          const videos = vPlayer.querySelectorAll('video')
          videos.forEach(video => {
            video.pause()
            video.src = ''
            video.load()
            vPlayer.removeChild(video)
          })
        }
      }
    },
    beforeDestroy() {
      this.destroyPlayer()
    }
  }
</script>
<style scoped lang="less">
  .videobox {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;

    & > div {
      width: 100%;
      height: 100%;
      background: 100%;
    }
  }

  #videoPlayer {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute1/lv2/appMonitor/camera/video.vue